<template>
  <div class="container">
    <h1>Please enter survey code.</h1>
    <div class="inputrow">
      <input type="text" id="surveycode" />
      <button @click="submit()"><h2>submit</h2></button>
    </div>
    <h5 id="errortext">Invalid code, please try again</h5>
  </div>
</template>

<script>
import axios from "axios";
import { baseurl } from "../api";
export default {
  methods: {
    submit() {
      const inputobj = document.getElementById("surveycode");
      const usercode = inputobj.value;
      axios.post(baseurl + "checkcode", { code: usercode }).then((r) => {
        if (r.data.exists) {
          this.$router.push("/" + usercode);
          return;
        }
        inputobj.classList.add("errored");
        document.getElementById("errortext").classList.add("shown");
      });
    },
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        this.submit();
      }
    });
  },
  name: "Home",
};
</script>

<style scoped>
.container {
  margin-bottom: 2rem;
}

input {
  border: 1px solid #555555;
  border-radius: 1rem;
  padding: 1rem 1rem;
  margin: 0 1rem;
  font-size: 1rem;
  font-weight: bold;
  height: 100%;
}

.errored {
  border: 1px solid #ff0000;
}
.errored:focus {
  outline-color: #ff0000;
}

button {
  background-color: #007bff;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
}
button > h2 {
  color: #ffffff;
  margin: 0.8rem 1rem;
}

.inputrow {
  display: flex;
  align-items: center;
}

h5 {
  text-align: left;
  margin: 0.3rem 1.7rem;
  color: #c70000;
  visibility: hidden;
}

.shown {
  visibility: visible;
}
</style>
